module.exports = __webpack_public_path__ + "img/caret-right.d4ee4582.svg";